'use strict';

export default function routes($stateProvider) {
  'ngInject';
  $stateProvider.state('main', {
    url: '/',
    template: '<main></main>',
    authenticate: true
  });
}



// WEBPACK FOOTER //
// ./client/app/main/main.routes.js